import { convexQuery } from "@convex-dev/react-query";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import { itemsGetAllFromMenu } from "~/api-refs";
import { ItemsEmptyState } from "~/components/menus/items/empty";
import { ItemCard } from "~/components/menus/items/item-card";
import { LoadingPanel } from "~/components/shared/loading-panel";
import { toConvexTableId } from "~/lib/convex-table-id";

export const Route = createFileRoute("/_authenticated/menus/$menuId/items/")({
  component: ItemsListPage,
});

function ItemsListPage() {
  const { menuId } = Route.useParams();

  const { data: result, isPending } = useQuery(
    convexQuery(itemsGetAllFromMenu, {
      menuId: toConvexTableId("menus", menuId),
      paginationOpts: { numItems: 100, cursor: null },
    })
  );

  if (isPending || !result) {
    return <LoadingPanel message="Loading items..." />;
  }

  const items = result.page;

  if (items.length === 0 || !items[0]) {
    return <ItemsEmptyState menuId={menuId} />;
  }

  return (
    <div
      className="grid grid-cols-[repeat(auto-fill,minmax(13rem,1fr))] gap-4"
      id="itemsContainer"
    >
      {items.map((item) => (
        <ItemCard item={item} key={item.id} menuId={menuId} />
      ))}
    </div>
  );
}
